<template>
  <div id="q-app">
    <router-view />
    <div class="hidden">
      <GolfCartIcon id="svg_icon_golf_cart" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RootStore } from './types/store';
import { useQuasar } from 'quasar';
import { computed } from 'vue';
import { useStore } from 'vuex';
import GolfCartIcon from 'src/assets/golf-cart-icon.svg?component';

const store = <RootStore>useStore();

const $q = useQuasar();

const isTouchOnly = computed(() => store.state.env.browserSupport.isTouchOnly);

function init() {
  store.dispatch('env/init');
}

if (window.location.hostname.includes('zubie.com')) {
  document.domain = 'zubie.com';
} else if (window.location.hostname.includes('zubiecar.com')) {
  document.domain = 'zubiecar.com';
}

if (!window.location.pathname.startsWith('/frame')) {
  init();
}

// Redirect old style invite links to correct location. We have to do this
// in Javascript because the hash fragment is never seen by the server. :-\
if (!$q.platform.is.capacitor && window.location.hash.startsWith('#/invite?token')) {
  window.location.replace(window.location.hash.substring(1));
}

if (isTouchOnly.value) {
  document.body.classList.add('touch-only');
}
</script>

<style src="animate.css/animate.min.css"></style>

<style lang="scss">
.mobile-notch-top .main-header {
  padding-top: var(--safe-area-top);
}
</style>
